import React from "react";

export const Button = ({
  children,
  className,
  onClick,
  borderColor = "border-black",
  ...props
}) => {
  return (
    <button
      onClick={onClick}
      className={`flex items-center justify-center gap-2 border w-auto rounded-lg px-2 py-2 bg-white ${borderColor} ${className}`}
      style={{ borderColor: borderColor }}
      {...props}
    >
      {children}
    </button>
  );
};
